(function () {
  function init() {
    var bar = document.getElementById('lia-sticky-purchase');
    var variantData = document.getElementById('lia-sticky-purchase-variants');
    if (!bar || !variantData || bar.dataset.ready === 'true') return;
    bar.dataset.ready = 'true';
    var button = bar.querySelector('[data-lia-sticky-add]');
    var buttonLabel = bar.querySelector('[data-lia-sticky-label]');
    var price = bar.querySelector('[data-lia-sticky-price]');
    var compare = bar.querySelector('[data-lia-sticky-compare]');
    var saveBadge = bar.querySelector('[data-lia-sticky-save]');
    var option = bar.querySelector('[data-lia-sticky-option]');
    var variants = {};
    try { variants = JSON.parse(variantData.textContent); } catch (error) { return; }
    function nativeControls() {
      var form = document.querySelector('#MainContent product-form form[data-type="add-to-cart-form"]');
      return {form: form, input: form && form.querySelector('input[name="id"]'), button: form && form.querySelector('button[name="add"]')};
    }
    function dockHeight() {
      if (window.innerWidth > 749) return 0;
      var dock = document.querySelector('#shopify-section-mobile-dock .mobile-dock');
      var rect = dock && dock.getBoundingClientRect();
      return rect && rect.height > 0 ? Math.ceil(rect.height) : 77;
    }
    function isOverlayOpen() {
      var body = document.body;
      if (!body) return true;
      return ['mini-cart--open','mini-cart--opening','mini-cart--closing','menu-drawer--open','menu-drawer--opening','menu-mobile--open','menu-mobile--opening','search-modal--open','quick-view--open','quick-view--opening'].some(function (name) {return body.classList.contains(name);}) || Boolean(document.querySelector('cart-drawer details[open], cart-drawer.is-active'));
    }
    function update() {
      var controls = nativeControls();
      var record = controls.input && variants[String(controls.input.value)];
      var available = Boolean(record && record.available && controls.button && !controls.button.disabled && controls.button.getAttribute('aria-disabled') !== 'true');
      if (record) {
        price.textContent = record.price;
        if (saveBadge) {
          var discount = Number(record.savePercent) || 0;
          saveBadge.hidden = !record.available || discount <= 0;
          if (discount > 0) saveBadge.textContent = bar.dataset.saveLabel + ' ' + discount + '%';
        }
        if (record.compare) {
          compare.textContent = record.compare;
          compare.hidden = false;
        } else {
          compare.textContent = '';
          compare.hidden = true;
        }
        if (option) {
          option.textContent = record.title !== 'Default Title' ? record.title : '';
          option.hidden = record.title === 'Default Title';
        }
      }
      button.disabled = !available;
      buttonLabel.textContent = available ? bar.dataset.addLabel : bar.dataset.soldLabel;
      var mobile = window.innerWidth <= 749;
      var nav = dockHeight();
      bar.style.setProperty('--lia-dock-height', nav + 'px');
      var rect = controls.button && controls.button.getBoundingClientRect();
      var visibleNative = Boolean(rect && rect.bottom > 65 && rect.top < window.innerHeight - (mobile ? nav + 12 : 0));
      var show = Boolean(controls.button && window.scrollY > (mobile ? 230 : 320) && !visibleNative && !isOverlayOpen());
      bar.classList.toggle('lia-sticky-purchase--visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    var queued = false;
    function scheduleUpdate() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {queued = false; update();});
    }
    button.addEventListener('click', function () {
      var controls = nativeControls();
      if (!controls.button) return;
      if (controls.button.disabled) {
        controls.button.scrollIntoView({behavior: 'smooth', block: 'center'});
        return;
      }
      controls.button.click();
      scheduleUpdate();
    });
    window.addEventListener('scroll', scheduleUpdate, {passive: true});
    window.addEventListener('resize', scheduleUpdate, {passive: true});
    document.addEventListener('change', scheduleUpdate);
    document.addEventListener('input', scheduleUpdate);
    document.addEventListener('variant:change', scheduleUpdate);
    document.addEventListener('shopify:section:load', scheduleUpdate);
    document.addEventListener('cart:updated', scheduleUpdate);
    var main = document.getElementById('MainContent');
    if (main && typeof MutationObserver !== 'undefined') {
      new MutationObserver(scheduleUpdate).observe(main, {childList: true, subtree: true, attributes: true, attributeFilter: ['value','disabled','aria-disabled']});
      new MutationObserver(scheduleUpdate).observe(document.body, {attributes: true, attributeFilter: ['class']});
    }
    scheduleUpdate();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();